import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

type ListToolbarProps = {
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
};

const Toolbar = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const LeftSlot = styled.div`
  display: flex;
  align-items: center;
  flex: 0 1 auto;
  min-width: 0;
`;

const RightSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
  flex: 1 1 22rem;
  min-width: 0;
`;

const ListToolbar: React.FC<ListToolbarProps> = ({
  left,
  right,
  className,
}) => (
  <Toolbar className={className}>
    {left ? <LeftSlot>{left}</LeftSlot> : null}
    {right ? <RightSlot>{right}</RightSlot> : null}
  </Toolbar>
);

ListToolbar.propTypes = {
  left: PropTypes.node,
  right: PropTypes.node,
  className: PropTypes.string,
};

export default ListToolbar;
